<template>
    <div>
        <navigation-tabs v-if="isRender" :tabs="tabs" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import NavigationTabs from './NavigationTabs.vue';

    export default {
        name: 'navigation-tabs-container',
        components: {
            NavigationTabs,
        },
        methods: {
            isActiveTab(route) {
                switch (route.path) {
                    case '/tariff/history':
                        return this.tariff && this.tariff.title !== undefined;
                    default:
                        return true;
                }
            }
        },
        computed: {
            ...mapGetters('profileTariff', ['tariff']),

            allTabs() {
                return this.$router.options.routes.reduce((routes, route) => {
                    if (!route.meta || !route.meta.tabs) {
                        return routes;
                    }

                    if (routes.hasOwnProperty(route.meta.tabs)) {
                        routes[route.meta.tabs].push(route);
                    } else {
                        routes[route.meta.tabs] = [route];
                    }

                    return routes;
                }, {});
            },
            isRender() {
                return this.$route.meta.tabs !== undefined && this.allTabs.hasOwnProperty(this.$route.meta.tabs);
            },
            tabs() {
                return this.isRender
                    ? this.allTabs[this.$route.meta.tabs]
                        .reduce((tabs, route) => {
                            tabs[route.path] = {
                                label: route.meta.tabTitle || route.meta.title,
                                active: this.isActiveTab(route),
                            };

                            return tabs;
                        }, {})
                    : {};
            }
        },
    }
</script>


// WEBPACK FOOTER //
// NavigationTabsContainer.vue?65616e2d